<template>
    <div id="topbar"
        :class="[{'bg-list': type == 'list'}, {'bg-detail': type == 'detail'}]">
        <div id="topbar_wrapper">
            <div id="topbar_close"
                @click="clickBack()">
                <img src="../../../assets/icon/ic_back_gray.svg" />
            </div>
            <div id="topbar_title" v-if="type == 'list'">{{title}}</div>
            <div id="topbar_point_info" v-if="!noShowPoint">
                <div id="topbar_point_lbl">{{lbl.detail.topbar_point_lbl}}</div>
                <div id="topbar_point_row">
                    <div id="topbar_point">{{$store.getters.getFormatted}}</div>
                    <img id="topbar_ic" src="../../../assets/icon/reward_icon_coin@3x.png" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js"
export default {
    name: 'TopBarDetail',
    props: {
        title: String,
        type: String, //list,detail
        noShowPoint: Boolean
    },
    data: function () {
        return {
            lbl: Locale.getLbl()
        }
    },
    methods: {
        clickBack: function () {
            this.$emit('clickBack');
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/base/baseDisplay.scss';
@import './TopBarMain.scss';
</style>
